import React, { useState, useEffect } from "react";
import { ImExit } from "react-icons/im";
// import { ThreeDots } from "react-loader-spinner";
import {
  signOut,
  updateProfile,
  updatePassword,
  reauthenticateWithCredential,
  EmailAuthProvider,
} from "firebase/auth";
import { doc, setDoc, getDoc } from "firebase/firestore";
import { auth, firestore } from "../firebase";

import check from "../img/check.gif";
import error from "../img/error.gif";

function Settings({ user }) {
  const [nameValue, setNameValue] = useState(user.displayName);
  const [emailValue, setEmailValue] = useState(user.email);
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [currPass, setcurrPass] = useState("");
  const [newPass, setnewPass] = useState("");
  const [confirmNewPass, setconfirmNewPass] = useState("");
  const [documentData, setDocumentData] = useState({});
  const [isSuccess, setIsSuccess] = useState(null);
  const [message, setMessage] = useState("");
  const [active, setActive] = useState("profile");

  console.log(user);
  useEffect(() => {
    // Fetch additional user data (phone and address) from Firestore when the component mounts
    async function fetchUserData() {
      const userDocRef = doc(firestore, "users", user.uid);
      const userDocSnapshot = await getDoc(userDocRef);

      if (userDocSnapshot.exists()) {
        const userData = userDocSnapshot.data();
        setDocumentData(userData);
        setPhone(userData.phone || "");
        setAddress(userData.address || "");
      }
    }

    fetchUserData();
  }, [user.uid]);

  const handleNameChange = (event) => {
    setNameValue(event.target.value);
  };
  const handleEmailChange = (event) => {
    setEmailValue(event.target.value);
  };
  const handlePhoneChange = (event) => {
    setPhone(event.target.value);
  };
  const handleAddressChange = (event) => {
    setAddress(event.target.value);
  };
  const handleCurrentPassChange = (event) => {
    setcurrPass(event.target.value);
  };
  const handleNewPassChange = (event) => {
    setnewPass(event.target.value);
  };
  const handleConfirmNewPassChange = (event) => {
    setconfirmNewPass(event.target.value);
  };

  const handleSave = async () => {
    // Update the user's profile with the new name and email
    if (nameValue !== user.displayName || emailValue !== user.email) {
      const userDocRef = doc(firestore, "users", user.uid);
      try {
        await updateProfile(auth.currentUser, {
          displayName: nameValue,
          email: emailValue,
        });
        await setDoc(
          userDocRef,
          {
            name: nameValue,
            email: emailValue,
          },
          { merge: true }
        );
        setIsSuccess(true);

        setTimeout(() => {
          setIsSuccess(null);
        }, 3000);
        setMessage("Profile updated successfully");
      } catch (error) {
        setIsSuccess(false);

        setTimeout(() => {
          setIsSuccess(null);
        }, 3000);
        setMessage("Error updating profile");
      }
    }

    if (phone !== documentData.phone || address !== documentData.address) {
      // Update the phone and address in Firestore
      const userDocRef = doc(firestore, "users", user.uid);
      try {
        await setDoc(
          userDocRef,
          {
            phone: phone,
            address: address,
          },
          { merge: true }
        );
        setIsSuccess(true);

        setTimeout(() => {
          setIsSuccess(null);
        }, 3000);
        setMessage("Profile updated successfully");
      } catch (error) {
        setIsSuccess(false);

        setTimeout(() => {
          setIsSuccess(null);
        }, 3000);
        setMessage("Error updating profile");
      }
    } else {
      console.log("Phone and Address is unchanged");
    }
  };

  const handleLogout = () => {
    signOut(auth)
      .then(() => {
        // Sign-out successful.
        console.log("Signed out successfully");
      })
      .catch((error) => {
        // An error happened.
        console.log(error);
      });
    window.location.reload();
  };

  const changePassword = async (e) => {
    e.preventDefault();

    if (user.providerData[0].providerId === "password") {
      try {
        const credential = EmailAuthProvider.credential(user.email, currPass);
        await reauthenticateWithCredential(user, credential);
        if (newPass === confirmNewPass && newPass !== "") {
          await updatePassword(user, newPass);
          setIsSuccess(true);
          setMessage("Password changed successfully");
          setcurrPass("");
          setnewPass("");
          setconfirmNewPass("");
        } else {
          setIsSuccess(false);
          setMessage("New password and confirmation do not match");
        }
      } catch (error) {
        setIsSuccess(false);
        setMessage("Error changing password:", error);
        console.error("Error changing password:", error);
      }
    }
  };

  // const deleteAccount = () => {
  //   console.log("delete account");
  // };

  return (
    <main id="settings">
      <div className="bg"></div>
      <div className="inner flex justify-center">
        <aside>
          <div className="options">
            <p
              className={active === "profile" ? "active" : ""}
              onClick={() => {
                setActive("profile");
              }}
            >
              Profile Settings
            </p>
            <p
              className={active !== "profile" ? "active" : ""}
              onClick={() => {
                setActive("account");
              }}
            >
              Account Settings
            </p>
          </div>
          <span onClick={handleLogout}>
            Log Out
            <ImExit />
          </span>
        </aside>
        {active === "profile" && (
          <section className="settings">
            <h3 className="big">Profile Settings</h3>
            {user.providerData[0].providerId !== "password" ? (
              <i>
                You can't edit your name and password because you signed in
                using a provider
              </i>
            ) : (
              ""
            )}
            <div className="input-block">
              <label>Name</label>
              <input
                type="text"
                value={nameValue}
                onChange={handleNameChange}
                placeholder="John Smith"
                disabled={user.providerData[0].providerId !== "password"}
              />
            </div>
            <div className="input-block">
              <label>Email</label>
              <input
                type="email"
                value={emailValue}
                onChange={handleEmailChange}
                placeholder="jsmith@gmail.com"
                disabled={user.providerData[0].providerId !== "password"}
              />
            </div>
            <div className="input-block">
              <label htmlFor="phone">Phone Number (optional)</label>
              <input
                type="tel"
                value={phone}
                onChange={handlePhoneChange}
                name="phone"
                placeholder="(554) 651-0312"
              />
            </div>
            <div className="input-block">
              <label htmlFor="address">Address</label>
              <textarea
                name="address"
                value={address}
                onChange={handleAddressChange}
                placeholder="117 Leda Plain, Utah, 33694"
              ></textarea>
            </div>

            <button onClick={handleSave} className="button button-primary2">
              Save
            </button>
          </section>
        )}

        {active === "account" && (
          <section className="account">
            <h3 className="big">Account Settings</h3>
            {user.providerData[0].providerId === "password" ? (
              <p
                onClick={() => {
                  setActive("password");
                }}
              >
                Change Password
              </p>
            ) : (
              <></>
            )}

            <p
              onClick={() => {
                setActive("delete");
              }}
            >
              Delete Account
            </p>
          </section>
        )}

        {active === "password" && (
          <section className="pass">
            <p
              className="flex align-center"
              onClick={() => {
                setActive("account");
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="1em"
                viewBox="0 0 448 512"
              >
                <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" />
              </svg>
              Back
            </p>
            <h3 className="big">Change Password</h3>
            <form onSubmit={changePassword}>
              {user.providerData[0].providerId === "password" && (
                <input
                  type="password"
                  placeholder="Current password"
                  onChange={handleCurrentPassChange}
                  value={currPass}
                />
              )}
              <input
                type="password"
                placeholder="New password"
                onChange={handleNewPassChange}
                value={newPass}
              />
              <input
                type="password"
                placeholder="Confirm new password"
                onChange={handleConfirmNewPassChange}
                value={confirmNewPass}
              />
              <button className="button button-primary2">Change</button>
            </form>
          </section>
        )}

        {active === "delete" && (
          <section className="del">
            <h3>Input OTP sent to email</h3>
            <input type="text" />
          </section>
        )}
      </div>

      {isSuccess !== null && (
        <div className="message flex align-center justify-center">
          <div className="inner flex column align-center justify-center">
            <button
              onClick={() => {
                setIsSuccess(null);
              }}
            >
              ╳
            </button>
            <img
              src={isSuccess ? check : isSuccess === null ? "" : error}
              alt={isSuccess ? "Success" : isSuccess === null ? "" : "Error"}
            />
            <p>{message}</p>
          </div>
        </div>
      )}
    </main>
  );
}

export default Settings;
